import { Box, BoxProps } from '@rossum/ui/material';
import { Link } from 'react-router-dom';

const StyledLink = (props: BoxProps<typeof Link> & { disabled?: boolean }) => (
  <Box
    component={Link}
    {...props}
    sx={{
      color: theme => theme.palette.secondary.main,
      textDecoration: 'none',
      '&:hover': {
        color: theme => theme.palette.secondary.light,
        textDecoration: !props.disabled ? 'underline' : 'none',
      },
      ...props.sx,
    }}
  />
);

export { StyledLink };
